// Herkunft einer Fahrt für die Markierungs-Chips (Fahrtenliste, LiveMap,
// Fahrtdetails). Einsteiger-Touren legt die Fahrer-App mit `walkInRide: true`
// an; `isPhoneCustomer` steht dort nur dafür, ob ein Bestandskunde erkannt
// wurde, und taugt deshalb nicht als Herkunft.

const WALK_IN_RIDE_SOURCES = ['driver_walk_in', 'driver_prescription_walk_in'];

export const isWalkInRide = (ride) => (
  ride?.walkInRide === true || WALK_IN_RIDE_SOURCES.includes(ride?.rideSource)
);

// 'walk_in' | 'phone' | 'app'
export const getRideOrigin = (ride) => {
  if (isWalkInRide(ride)) return 'walk_in';
  return ride?.isPhoneCustomer ? 'phone' : 'app';
};

// `label` für die kompakten Listen-Chips, `longLabel` für die Fahrtdetails.
// `color` ist die Palette: Einsteiger blau, Telefon orange, App grün.
export const RIDE_ORIGIN_META = {
  walk_in: { label: 'Einsteiger', longLabel: 'Einsteiger-Tour', color: 'info' },
  phone: { label: 'Telefon', longLabel: 'Telefonkunde', color: 'warning' },
  app: { label: 'App', longLabel: 'App-Kunde', color: 'success' },
};
